import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { GutterFull } from '../../common/components/layout';
import Layout from '../../common/layout';
import { supabase } from '../../lib/supabase';
import { useAuthRedirect } from '../../common/hooks/use-me';

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}

export default function LoginPage() {
  useAuthRedirect({ authed: true, to: '/' });
  const [loading, setLoading] = useState<string | null>(null);

  const handleGoogleLogin = async () => {
    setLoading('google');
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/`,
      },
    });
    if (error) {
      toast.error(error.message);
      setLoading(null);
    }
  };

  const handleAppleLogin = async () => {
    setLoading('apple');
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'apple',
      options: {
        redirectTo: `${window.location.origin}/`,
      },
    });
    if (error) {
      toast.error(error.message);
      setLoading(null);
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>Sign In</title>
      </Helmet>
      <GutterFull>
        <div className="flex flex-col items-center justify-center w-full">
          <div className="w-full max-w-sm">
            <div className="text-center mb-8">
              <div className="text-6xl mb-4">🍜</div>
              <h1 className="text-2xl font-bold">Welcome to Twenty Seconds</h1>
              <p className="text-gray-500 mt-2">Sign in to continue</p>
            </div>

            <div className="flex flex-col gap-3">
              <button
                onClick={handleGoogleLogin}
                disabled={loading !== null}
                className="btn btn-outline gap-3 normal-case"
              >
                <GoogleIcon />
                {loading === 'google' ? 'Redirecting...' : 'Continue with Google'}
              </button>

              <button
                onClick={handleAppleLogin}
                disabled={loading !== null}
                className="btn gap-3 normal-case bg-black text-white hover:bg-gray-800 border-black"
              >
                <AppleIcon />
                {loading === 'apple' ? 'Redirecting...' : 'Continue with Apple'}
              </button>
            </div>
          </div>
        </div>
      </GutterFull>
    </Layout>
  );
}
